module.exports = __webpack_public_path__ + "static/media/profiles73ba469e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/practice_admin/images/profiles.svg
// module id = 1511
// module chunks = 0